import { v4 as uuid } from 'uuid';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

/**
 * Creates unique ID: "timestamp_randomString"
 */
export const generateFlowId = () => {
  return `${Date.now()}_${uuid()}`;
};

export const trackIcaAssortmentCreateProductClick = (params: {
  userId: string;
  flowId: string;
  ean: string;
  productName?: string;
}) => {
  const data = {
    event: 'ica_assortment_create_product_click',
    flow_id: params.flowId,
    user_id: params.userId,
    product_source: 'ica_assortment',
    product_ean: params.ean,
    product_name: params.productName,
    timestamp: new Date().toISOString(),
  };
  console.log('>>> trackIcaAssortmentCreateProductClick', data);
  window.dataLayer.push(data);
};

export const trackCreateProductFormView = (params: { userId: string; flowId: string; source: string; ean: string }) => {
  const data = {
    event: 'create_product_form_view',
    flow_id: params.flowId,
    user_id: params.userId,
    product_source: params.source,
    product_ean: params.ean,
    timestamp: new Date().toISOString(),
  };
  console.log('>>> trackCreateProductFormView', data);
  window.dataLayer.push(data);
};
